<template>
  <div class="panel" :style="`background-color: ${backgroundColor};margin: ${marginY} 0;`">
    <slot></slot>
  </div>
</template>

<style scoped>
.panel {
  border: 1px solid #ebebeb;
  padding: 20px;
  box-shadow: 0px 3px 10px rgb(18 42 66 / 8%);
}

.panel:first-child{
  margin-top: 0;
}

.panel h2:first-child, .panel h3:first-child, .panel h4:first-child{
  margin-top: 0;
}
</style>

<script>
export default {
  components: {},
  props: {
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    marginY: {
      type: String,
      default: 'clamp(24px, 2.222vw, 32px)'
    }
  },
  data: () => ({

  }),
}
</script>
